module.exports = __webpack_public_path__ + "static/media/nav-logo.d1770afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/nav-logo.png
// module id = 9
// module chunks = 0